<template>
  <section class='common-tip'>
    <ul>
      <transition-group name='tip'>
        <li
          v-for='item in domList'
          :key='item.time'
          class='common-tip-even main-second-bg main-cl'
          :class='item.color'
        >
          <span class='icon'></span>
          <svg-icon
            v-if='item.type === "info" || item.type === "warning"'
            iconClass="warningIcon"
            className="icon icon-16"></svg-icon>
          <svg-icon
            v-if='item.type === "error"'
            iconClass="tip-error"
            className="icon icon-16"></svg-icon>
          <svg-icon
            v-if='item.type === "success"'
            iconClass="tip-success"
            className="icon icon-16"></svg-icon>
          <!-- <svg
            v-if='item.type === "info"'
            class='icon icon-16'
            aria-hidden='true'
          >
            <use xlink:href='#icon-c_3'></use>
          </svg>
          <svg
            v-if='item.type === "error"'
            class='icon icon-16'
            aria-hidden='true'
          >
            <use xlink:href='#icon-c_5'></use>
          </svg>
          <svg
            v-if='item.type === "success"'
            class='icon icon-16'
            aria-hidden='true'
          >
            <use xlink:href='#icon-c_4'></use>
          </svg>
          <svg
            v-if='item.type === "warning"'
            class='icon icon-16'
            aria-hidden='true'
          >
            <use xlink:href='#icon-c_6'></use>
          </svg> -->
          <div class='text'>{{ item.text }}</div>
          <div class='desc'>{{ item.desc }}</div>
        </li>
      </transition-group>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'c-tip',
  data() {
    return {
      list: [
        // { text: 'error', time: 3000, type: 'error' },
        // { text: 'success', time: 3000, type: 'success' },
        // { text: 'info', time: 3000, type: 'info' },
        // { text: 'warning', time: 3000, type: 'warning' }
      ],
    };
  },
  computed: {
    domList() {
      const list = [];
      this.list.forEach((item) => {
        let color = '';
        switch (item.type) {
          // case 'error':
          //   color = 'red-bd';
          //   break;
          case 'success':
            color = 'green-bd';
            break;
          // case 'info':
          //   color = 'blue-bd';
          //   break;
          // case 'warning':
          //   color = 'a-20-bd';
          //   break;
          default:
            color = 'red-bd';
        }
        list.push({ ...item, ...{ color } });
      });
      return list;
    },
  },
  mounted() {
    this.$bus.$on('tip', ({ text, desc = '', type = 'info' }) => {
      const time = new Date().getTime();
      this.list.unshift({
        text,
        desc,
        type,
        time,
      });
      setTimeout(() => {
        let id = -1;
        this.list.forEach((item, index) => {
          if (item.time === time) id = index;
        });
        this.list.splice(id, 1);
      }, 3000);
    });
  },
};
</script>

<style lang="scss" scoped>
.tip-item-move {
  display: inline-block;
  margin-right: 10px;
}

.tip-enter-active, .tip-leave-active {
  transition: all 0.3s;
}

.tip-enter, .tip-leave-to {
  opacity: 0;
  transform: translateX(30%);
}

.common-tip {
  position: fixed;
  right: 0;
  top: 164px;
  z-index: 9999;

  .info {
    border-left-width: 4px;
    border-left-style: solid;
  }

  .common-tip-even {
    box-shadow: 0 2px 10px rgba(0,0,0,0.15);
    max-width: 345px;
    min-height: 64px;
    margin-bottom: 24px;
    border-left-width: 4px;
    border-left-style: solid;
    box-sizing: border-box;
    transition: all 0.3s;
    padding: 21px 24px 21px 45px;
    position: relative;

    .icon {
      position: absolute;
      width: 16px;
      height: 16px;
      top: 24px;
      left: 24px;
      border-radius: 50%;
    }

    .text{
      font-family: 'Medium';
      font-size: 15px;
      letter-spacing: 0;
      text-align: left;
      line-height: 22px;
    }

    .desc {
      font-size: 12px;
      line-height: 18px;
      letter-spacing: 0;
      text-align: left;
      font-family: 'Medium';
      margin-top: 4px;
    }
  }
}
</style>
